import * as React from 'react';
import { Alert, AlertDescription, AlertTitle, Button } from '@repo/ui-web';
import { alertStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

const titleByVariant = {
  info: 'Heads up',
  success: 'Success',
  warning: 'Warning',
  error: 'Something went wrong',
} as const;

const descriptionByVariant = {
  info: 'We updated your settings. Review them before saving.',
  success: 'Your profile has been updated successfully.',
  warning: 'This action is permanent and cannot be undone.',
  error: 'We could not save your changes. Try again.',
} as const;

type AlertVariant = (typeof alertStates)[number];

const primaryVariantForAlert: Record<AlertVariant, 'default' | 'destructive'> = {
  info: 'default',
  success: 'default',
  warning: 'default',
  error: 'destructive',
};

const secondaryVariantForAlert: Record<AlertVariant, 'outline' | 'destructive-outline'> = {
  info: 'outline',
  success: 'outline',
  warning: 'outline',
  error: 'destructive-outline',
};

export function AlertShowcase() {
  const [variant, setVariant] = React.useState<AlertVariant>('info');

  return (
    <div className="space-y-4">
      <StateToggle options={alertStates} value={variant} onChange={setVariant} label="Variant" />
      <Alert variant={variant}>
        <AlertTitle>{titleByVariant[variant]}</AlertTitle>
        <AlertDescription>{descriptionByVariant[variant]}</AlertDescription>
        <div className="mt-3 flex gap-3">
          <Button size="md" variant={secondaryVariantForAlert[variant]}>
            Cancel
          </Button>
          <Button size="md" variant={primaryVariantForAlert[variant]}>
            Accept
          </Button>
        </div>
      </Alert>
    </div>
  );
}
